export const OppurtunityValidation = (formData) => {
    const errors = {};

    if (formData.formData.OppType == "1") {
        if (!formData.formData.CustomerID || formData.formData.CustomerID == "0") {
            errors.CustomerID = 'This field is required';
        }
    }
    if (!formData.formData.vc_Topic || !formData.formData.vc_Topic.trim()) {
        errors.vc_Topic = 'This field is required';
    }

    if (!formData.formData.vc_FirstName || !formData.formData.vc_FirstName.trim()) {
        errors.vc_FirstName = 'This field is required';
    }
    if (!formData.formData.vc_Surname || !formData.formData.vc_Surname.trim()) {
        errors.vc_Surname = 'This field is required';
    }
    if (!formData.formData.vc_Address1 || !formData.formData.vc_Address1.trim()) {
        errors.vc_Address1 = 'This field is required';
    }
    if (formData.formData.FK_LeadOpportunitySource_Id === "0") {
        errors.FK_LeadOpportunitySource_Id = 'This field is required';
    }

    if (formData.formData.FK_LeadOpportunityStatus_ID === "0") {
        errors.FK_LeadOpportunityStatus_ID = 'This field is required';
    }
    if (formData.formData.FK_TaxCode_Id === "0") {
        errors.FK_TaxCode_Id = 'This field is required';
    }
    if (formData.formData.FK_Currency_Id === "0") {
        errors.FK_Currency_Id = 'This field is required';
    }
    if (formData.formData.NoOfEmployees) {
        if (!/^\d+$/.test(formData.formData.NoOfEmployees)) {
            errors.NoOfEmployees = 'Only whole numbers are allowed';
        }
    }
    else {
        formData.formData.NoOfEmployees = 0;
    }
    if (formData.formData.vc_Email) {
        if (!isValidEmail(formData.formData.vc_Email)) {
            errors.vc_Email = 'Please enter a valid email address';
        }
    }



    return errors;
};
const isValidEmail = (email) => {
    // You can implement a regex or use a library like validator.js to validate email format
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
